module.exports = __webpack_public_path__ + "img/select-invoice.df411c35.png";